interface GuidanceFields {
  guidance?: string | null;
  guidanceRemoved?: boolean;
}

/** Preserve user guidance while recording an explicit clear action. */
export function applyGuidanceEdit<T extends GuidanceFields>(
  previous: T,
  edited: T
): T & { guidance: string | null; guidanceRemoved: boolean } {
  const hasEditedGuidance = Boolean(edited.guidance?.trim());
  const hadVisibleGuidance = Boolean(previous.guidance?.trim());
  return {
    ...edited,
    guidance: hasEditedGuidance ? edited.guidance : null,
    guidanceRemoved: hasEditedGuidance
      ? false
      : hadVisibleGuidance || Boolean(previous.guidanceRemoved),
  };
}

/** Convert working rows into the public API submission shape. */
export function mapBenSpecQuestionsForApi(
  rows: BenSpecQuestionRow[]
): BenefitSpecificationsJobRequest["questions"] {
  return rows.map((row) => ({
    id: row.id,
    section: row.section,
    sub_section: row.subSection || null,
    sub_sub_section: row.subSubSection || null,
    question_label: row.questionLabel,
    question: row.question,
    heading_path: buildHeadingPath(row.section, row.subSection ?? "", row.subSubSection ?? ""),
    guidance: row.guidance ?? null,
    guidance_removed: row.guidanceRemoved ?? false,
  }));
}
import { buildHeadingPath } from "./benSpecQuestionsCsv";
import type { BenSpecQuestionRow, BenefitSpecificationsJobRequest } from "../types";
